/** Validators barrel + the per-action dispatcher. */
import type { AugmentedWarAction } from "../types/action";
import { invalid, type ValidationResult } from "../types/common";
import type { AugmentedWarState } from "../types/game-state";
import {
  validateAttack,
  validateDeclareAttack,
  validateResolveAttack,
} from "./attack.validator";
import { validateDeploy } from "./deploy.validator";
import { validateEndTurn } from "./end-turn.validator";
import { validateMove } from "./move.validator";

export {
  validateAttack,
  validateDeclareAttack,
  validateResolveAttack,
} from "./attack.validator";
export { validateDeploy } from "./deploy.validator";
export { validateEndTurn } from "./end-turn.validator";
export { validateMove } from "./move.validator";

export function validateAction(
  state: AugmentedWarState,
  action: AugmentedWarAction,
): ValidationResult {
  // A declared attack freezes the game: only the defender's ResolveAttack is
  // legal until the clash is settled (2-step live combat, rule.md §7.1).
  if (state.pendingAttack && action.type !== "ResolveAttack") {
    return invalid("A declared attack is awaiting the defender's response");
  }

  switch (action.type) {
    case "Move":
      return validateMove(state, action);
    case "Attack":
      return validateAttack(state, action);
    case "DeclareAttack":
      return validateDeclareAttack(state, action);
    case "ResolveAttack":
      return validateResolveAttack(state, action);
    case "Deploy":
      return validateDeploy(state, action);
    case "EndTurn":
      return validateEndTurn(state, action);
  }
}
